import { type FC } from 'react';

import { Button, ButtonProps } from '@/components/shadcn/ui/button';
import { cn } from '@/utils';

import { useDogeWallet } from '../../hooks';

import { ConnectedDogeWalletButton } from './components';

export const ConnectedDogeWallet: FC<ButtonProps> = ({ className, children, ...props }) => {
  const { connect, isConnected } = useDogeWallet();
  if (!isConnected) {
    return (
      <Button
        variant="secondary"
        size="sm"
        className={cn('font-cocogoose rounded-xl text-sm font-bold', className)}
        onClick={() => {
          void connect();
        }}
        {...props}
      >
        {children || 'Connect Doge Wallet'}
      </Button>
    );
  }

  return (
    <ConnectedDogeWalletButton {...props} className={className}>
      {children}
    </ConnectedDogeWalletButton>
  );
};
